import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation,Link } from 'react-router-dom';
import AuthContainer from '../../../components/auth/AdminAuthContainer';
import AuthHeader from '../../../components/auth/AdminAuthHeader';
import Card from '../../../components/ui/Card';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

import { toast } from 'react-toastify';
import { useAdminAuth } from '../../../contexts/AdminAuthContext';
import 'react-toastify/dist/ReactToastify.css';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isAuthenticated } = useAdminAuth();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    //rememberMe: false
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Redirect if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      const from = location.state?.from?.pathname || '/hpanel/dashboard';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, location]);

  const validateForm = () => {
    const newErrors = {};
    
    // Email validation
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    
    // Password validation
    if (!formData.password) {
      newErrors.password = 'Password is required';
    } else if (formData.password.length < 6) {
      newErrors.password = 'Password must be at least 6 characters';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  /*const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };*/

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }
    
    setLoading(true);
    
    try {
      const response = await login(formData.email, formData.password);
      
      toast.success(response.message || 'Login successful!');
      
      // Redirect to dashboard or intended page
      const from = location.state?.from?.pathname || '/hpanel/dashboard';
      navigate(from, { replace: true });
      
    } catch (error) {
      // Error is already handled by the interceptor, but we can add specific handling here
      if (error.response?.data?.errors) {
        // Handle validation errors from server
        const serverErrors = {};
        error.response.data.errors.forEach(err => {
          if (err.path) {
            serverErrors[err.path] = err.msg;
          }
        });
        setErrors(serverErrors);
      }
      
      // Clear password on error
      setFormData(prev => ({ ...prev, password: '' }));
      
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* SEO Settings */}
      <title>{`Admin Login | ${process.env.REACT_APP_NAME}`}</title>
      <meta name="robots" content="noindex, nofollow" />

      <AuthContainer>
        <AuthHeader 
          title="" 
          subtitle="" 
        />
        
        <Card>
          <form onSubmit={handleSubmit}>
            <Input
              type="email"
              name="email"
              label="Admin Email"
              icon="fas fa-envelope"
              placeholder="admin@hunarpool.com"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {errors.email && (
              <p className="mt-1 text-sm text-red-600">{errors.email}</p>
            )}
            
            <Input
              type="password"
              name="password"
              label="Password"
              icon="fas fa-lock"
              placeholder="••••••••"
              value={formData.password}
              onChange={handleChange}
              required
            />
            {errors.password && (
              <p className="mt-1 text-sm text-red-600">{errors.password}</p>
            )}

            <div className="flex items-center justify-between mb-6">
              {/* <div className="flex items-center">
                <input
                  type="checkbox"
                  id="rememberMe"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                  className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                />
                <label htmlFor="rememberMe" className="ml-2 block text-sm text-gray-700">
                  Remember me
                </label>
              </div> */}
              
              <Link 
                to="/hpanel/forgot-password" 
                className="text-primary-600 text-sm font-medium hover:text-primary-700"
              >
                Forgot Password?
              </Link>
            </div>
            
            <Button type="submit" variant="primary" className="w-full mb-4" disabled={loading}>
              { loading ? ('Signing in...') : ('Sign In to Admin Panel') }
            </Button>
            
            {/* <div className="text-center">
              <p className="text-gray-600 text-sm">
                Need admin access?{' '}
                <button type="button" className="text-primary-600 font-medium hover:text-primary-700">
                  Contact Super Administrator
                </button>
              </p>
            </div> */}
          </form>

          {/* Demo Credentials */}
          {/* <div className="mt-8 p-4 bg-primary-50 rounded-xl border border-primary-100">
            <h3 className="text-sm font-medium text-primary-800 mb-2">Demo Admin Credentials:</h3>
            <p className="text-xs text-primary-700">Email: admin@hunarpool.com</p>
            <p className="text-xs text-primary-700">Password: demo123</p>
          </div> */}
        </Card>
        
        {/* Footer */}
        {/* <div className="text-center mt-8">
          <p className="text-white/70 text-sm">HunarPool Admin. All rights reserved.</p>
        </div> */}
      </AuthContainer>
    </>
  );
};

export default Login;